const QUOTE_MARK_PATH =
  "M51.767 86V44.53q0-17.533 6.958-28.666Q65.96 4.454 77.094 0l7.236 17.534q-6.4 2.505-10.02 8.628-3.34 5.845-3.34 17.812h18.648V86zM0 86V44.53q0-17.533 6.958-28.666Q14.194 4.454 25.327 0l7.236 17.534q-6.4 2.505-10.02 8.628-3.34 5.845-3.34 17.812h18.648V86z";

/**
 * Decorative opening quote graphic. Sized in `em` against the quote it sits
 * inside, so it tracks the testimonial's `quote_size`. Hidden from assistive
 * technology — the surrounding `blockquote` already conveys that this is a
 * quote.
 */
export function QuoteMark() {
  return (
    <svg
      aria-hidden="true"
      className="testimonials2-mark"
      fill="none"
      focusable="false"
      viewBox="0 0 90 86"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d={QUOTE_MARK_PATH} fill="currentColor" />
    </svg>
  );
}
